
export const Footer = () => {
  return (
    <footer className="footer py-5">
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-8 mb-4 mx-auto text-center">
            <Link to="https://biz-node.app/company" target="_blank" className="text-secondary me-xl-5 me-3 mb-sm-0 mb-2">
              Company
            </Link>
            <Link to="https://biz-node.app/pricing" target="_blank" className="text-secondary mb-sm-0 mb-2">
              Pricing
            </Link>
          </div> */}
        </div>
        <div className="row">
          <div className="col-8 mx-auto text-center mt-1">
            <p className="mb-0 text-secondary text-xs">Copyright © {new Date().getFullYear()} Sculd.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
